//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapMutations } from 'vuex'
import seo from '~/mixins/seo'
import dealerCountriesQuery from '~/apollo/queries/dealer/countries'
import dealersQuery from '~/apollo/queries/dealer/dealers-country'
import filter from '~/mixins/filter'

export default {
  mixins: [seo, filter],
  data () {
    return {
      country: '',
      state: '',
      location: null,
      fetched: false
    }
  },
  apollo: {
    dealerCountries: {
      query: dealerCountriesQuery,
      prefetch: true
    },
    dealers: {
      query: dealersQuery,
      prefetch: true,
      variables () {
        return { country: this.country }
      },
      result ({ data, loading, networkStatus }) {
        this.fetched = true
      },
      error (error) {
        console.log(error)
        this.fetched = true
      }
    }
  },
  async fetch () {
    // see https://geojs.io/
    this.location = await this.$http.$get('https://get.geojs.io/v1/ip/country.json')
      .then((response) => { return response.name })
      .catch((e) => { console.log(e) })
  },
  fetchOnServer: false,
  computed: {
    filteredDealers () {
      return this.dealers
        ? this.dealers.filter((dealer) => {
          return (!this.state || (dealer.dealer_state && dealer.dealer_state.name === this.state))
        })
        : null
    },
    promotedDealers () {
      return this.dealers
        ? this.dealers.filter((dealer) => {
          return (!this.state || (dealer.dealer_state && dealer.dealer_state.name === this.state)) &&
            dealer.promoted
        })
        : null
    },
    sortedDealers () {
      const recs = this.filteredDealers

      if (recs) {
        recs.sort((a, b) => {
          if (!a.dealer_state) {
            return 1
          }
          if (!b.dealer_state) {
            return -1
          }
          if (a.dealer_state.name > b.dealer_state.name) {
            return 1
          }
          if (a.dealer_state.name < b.dealer_state.name) {
            return -1
          }
          return 0
        })
      }
      return recs
    },
    selectedCountry () {
      return this.dealerCountries ? this.dealerCountries.find(dealerCountry => dealerCountry.name === this.country) : null
    }
  },
  watch: {
    country () {
      if (this.country !== this.$store.getters['dealers/country']) {
        this.state = ''
      }
      this.setCountry(this.country)
      this.fetched = false
    },
    state () {
      this.setCountryState(this.state)
    },
    location () {
      console.log('Detected region: ' + this.location)
      if (!this.country && this.location) {
        this.country = this.location
      }
    }
  },
  created () {
    this.seoTitle = 'Dealers'
  },
  mounted () {
    this.setDealers(JSON.parse(localStorage.getItem('dealers')))
    this.country = this.$store.getters['dealers/country']
    this.state = this.$store.getters['dealers/countryState']
  },
  methods: {
    ...mapMutations({
      setDealers: 'dealers/setDealers',
      setCountry: 'dealers/setCountry',
      setCountryState: 'dealers/setState'
    }),
    scrollToTop () {
      this.scrollIntoView('top')
    },
    scrollIntoView (element) {
      const myElement = this.$refs[element]
      if (myElement) {
        myElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        })
      }
    }
  }
}

